var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.623 19.016-5.477-5.477a5.21 5.21 0 0 1-1.616.78 6.184 6.184 0 0 1-1.753.274c-1.497 0-2.765-.52-3.804-1.557-1.04-1.04-1.559-2.3-1.559-3.782 0-1.482.52-2.742 1.559-3.781 1.04-1.04 2.3-1.559 3.78-1.559 1.483 0 2.747.52 3.793 1.559 1.047 1.04 1.57 2.3 1.57 3.78 0 .597-.091 1.185-.275 1.765a5.014 5.014 0 0 1-.779 1.536l5.524 5.523-.963.94Zm-8.846-5.752c1.13 0 2.082-.382 2.853-1.146.772-.763 1.157-1.718 1.157-2.864s-.385-2.1-1.157-2.865c-.771-.764-1.722-1.146-2.853-1.146-1.146 0-2.104.382-2.876 1.146-.772.764-1.158 1.72-1.158 2.865 0 1.146.386 2.1 1.158 2.864.772.764 1.73 1.146 2.876 1.146Z",
    fill: "#000"
  })));
};
export default SvgSearch;